// extracted by mini-css-extract-plugin
export default {"channels":"ChannelIcons_channels__Qlawd","channel":"ChannelIcons_channel__N76OI"};